import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";

export function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="bg-sylhet-forest text-cream grain">
      <div className="max-w-content mx-auto px-6 md:px-12 py-16 md:py-24 relative z-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="relative w-9 h-9 rounded-full overflow-hidden bg-cream/10 grid place-items-center">
                <span className="w-5 h-5 rounded-full bg-sylhet-red" />
              </span>
              <span className="font-display font-extrabold text-2xl">Made in Sylhet</span>
            </div>
            <p className="text-cream/70 max-w-sm leading-relaxed">
              A reel-making competition celebrating the people, land and culture of the Sylhet division.
            </p>
            <p className="font-bn text-cream/60 mt-3">সিলেটের গল্প, সিলেটের মানুষ।</p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-cream/50 mb-4">Explore</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="hover:text-sylhet-gold transition-colors">Home</Link></li>
              <li><Link to="/submit" className="hover:text-sylhet-gold transition-colors">Submit a Reel</Link></li>
              <li><Link to="/about" className="hover:text-sylhet-gold transition-colors">About Fahim Al Choudhury</Link></li>
              <li><Link to="/admin" className="hover:text-sylhet-gold transition-colors">Organiser Login</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-cream/50 mb-4">Presented by</h4>
            <p className="font-display text-lg">Fahim Al Choudhury</p>
            <p className="text-cream/60 text-sm mt-1 mb-5">Entrepreneur & Philanthropist</p>
            <div className="flex gap-3">
              {[Youtube, Facebook, Instagram].map((Icon, i) => (
                <span key={i} className="w-10 h-10 rounded-full border border-cream/20 grid place-items-center hover:bg-cream/10 transition-colors cursor-pointer">
                  <Icon size={18} />
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-cream/10 mt-14 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-sm text-cream/50">
          <span>© {new Date().getFullYear()} madeinsylhet.com — All rights reserved.</span>
          <span className="font-bn">ভালোবাসা দিয়ে তৈরি · সিলেট</span>
        </div>
      </div>
    </footer>
  );
}
